import tokenData from '../../design-tokens/base-tokens.json';
export const MuiInputLabel = {
    styleOverrides: {
        root: ({ theme }) => ({
            position: 'relative',
            ...theme.typography.label,
            color: tokenData.tokens.palette.text.text200,
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            transform: 'none',
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled
            },
            '&.Mui-focused': {
                color: tokenData.tokens.palette.text.text300
            },
            '&.Mui-error': {
                color: tokenData.tokens.palette.text.text300
            }
        })
    }
};
export const MuiFormLabel = {
    styleOverrides: {
        root: ({ theme }) => ({
            ...theme.typography.label,
            color: tokenData.tokens.palette.text.text200,
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled
            }
        })
    }
};
export const MuiFormControlLabel = {
    styleOverrides: {
        label: {
            color: tokenData.tokens.palette.text.text200,
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled
            }
        },
        root: {
            '& .MuiRadio-root + .MuiFormControlLabel-label': {
                marginLeft: '4px'
            },
            '& .MuiSwitch-root + .MuiFormControlLabel-label': {
                marginLeft: '8px'
            }
        }
    }
};
export const MuiFormHelperText = {
    styleOverrides: {
        contained: ({ theme }) => ({
            marginLeft: '0px',
            marginRight: '0px',
            ...theme.typography.body2,
            color: tokenData.tokens.palette.text.text100,
            '&.Mui-error': {
                color: tokenData.tokens.palette.red.red600
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled
            }
        }),
        root: ({ theme }) => ({
            color: tokenData.tokens.palette.text.text100,
            ...theme.typography.body2,
            marginTop: 4,
            verticalAlign: 'middle',
            '& .MuiSvgIcon-root, svg, span': {
                verticalAlign: 'middle'
            },
            '& svg': {
                marginRight: '4px'
            }
        })
    }
};
